import { v4 as uuidv4 } from 'uuid';

export function getFile(response, externalFilename = null) {
  var result = document.createElement('a');
  var contentDisposition = response.headers['content-disposition'] || '';

  let extension = response.headers['content-type'].split('/')[1];

  if (externalFilename) {
    filename = externalFilename + '.' + extension;
  } else {
    var filename = contentDisposition.split('filename=')[1];
    if (filename && filename.indexOf(';') > 0) {
      filename = filename.split(';')[0];
      filename = filename.replace(/"/g, '');
    } else {
      filename = uuidv4();
      filename = filename + '.' + extension;
    }
  }

  result.href = window.URL.createObjectURL(response.data);
  result.target = '_self';
  result.download = filename;

  //saveFile(response.data, filename);

  return result;
}

function saveFile(blob, filename) {
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  }
}
